export default __webpack_public_path__ + "static/media/mark.bae6cb09.svg";